// eslint-disable-next-line
import React from "react";
import Moment from "moment";

export const formatImage = data => {
  const { Media, package_type, lolol_voucher } = data;
  let voucher_image = require("../assets/img/default-cover.png");

  if (Media.length > 0) {
    if (Media[0] && Media[0].path) {
      voucher_image = Media[0].path;
    }
  } else {
    switch (package_type) {
      case "V": // Cash Voucher
        voucher_image = lolol_voucher
          ? require("../assets/img/lolol_cash_voucher_app.jpg")
          : require("../assets/img/merchant_cash_voucher_app.jpg");
        break;
      case "C": // Product Voucher
        voucher_image = lolol_voucher
          ? require("../assets/img/lolol_food_voucher_app.jpg")
          : require("../assets/img/merchant_food_voucher_app.jpg");
        break;
      case "D": // Discount Voucher
        break;
      default:
        break;
    }
  }

  return voucher_image;
};

export const formatAvailableTime = time => {
  let available_time = "";
  if (time === "[]") {
    available_time = "All Day Available";
  } else {
    try {
      let time_array = JSON.parse(time);
      time_array.forEach((time, i) => {
        if (i === 0) {
          available_time = time;
        }
        if (time_array.length > 1) {
          available_time += "...";
        }
      });
    } catch (error) {
      console.warn("Failed to parsed available time");
    }
  }

  return available_time;
};

export const formatPercentage = (item_price, package_price) => {
  let percentage = "";
  percentage = ((item_price - package_price) / item_price) * 100;
  return parseInt(percentage) + "%";
};

export const formatValidUntil = date => {
  return Moment(date).format("YYYY-MM-DD");
};

export const formatVoucherIcon = data => {
  const { package_type, lolol_voucher } = data;
  let voucher_icon = require("../assets/img/default-profile.png");
  let type = "cash";
  let voucherBy = lolol_voucher ? "lolol" : "merchant";

  switch (package_type) {
    case "V": // Cash Voucher
      type = "cash";
      break;
    case "C": // Product Voucher
      type = "food";
      break;
    case "D": // Discount Voucher
      break;
    default:
      break;
  }

  voucher_icon = require(`../assets/img/${voucherBy}_${type}_icon.png`);

  return voucher_icon;
};
